import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from "../../../environments/environment";

@Directive({
  selector: '[appHideProd]',
  standalone: true
})
export class HideProdDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    if (!environment.production) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
